/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef, useState } from 'react';
import { Field, Formik, FieldArray, ErrorMessage } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import {
  Button,
  Box,
  CircularProgress,
  Divider,
  Grid,
  FormHelperText,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Chip,
  Tooltip,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Autocomplete,
  // List,
  // ListItem,
  // ListItemText,
  Stack
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HelpIcon from '@mui/icons-material/Help';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import UploadIcon from '@mui/icons-material/Upload';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import DatePicker from 'react-datepicker';
import ImageUploading from 'react-images-uploading';
import dateFormat from 'dateformat';
import DeptAction from '../../store/actions/DepartmentAction';
import globalAction from '../../store/actions/GlobalAction';
import PaymentAction from '../../store/actions/PaymentAction';
import UomAction from '../../store/actions/UomAction';
import CompanyAction from '../../store/actions/CompanyAction';
import ClientAction from '../../store/actions/ClientAction';
import CurrencyAction from '../../store/actions/CurrencyAction';
// import Logo from '../../assets/images/logo_image.png';
import QuantityNumberField from '../../components/Quantity';
import DecimalNumberField from '../../components/DecimalNumber';
import PendingPaymentRequest from './pendinig_request';
import { ValidatePaymentRequest } from '../../assets/validation';

function PaymentRequestAdd() {
  const [velanAddress, setVelanAddress] = useState(null);
  const [clientInfo, setClientInfo] = useState(null);
  const [purchaseType, setPurchateType] = useState('');
  const formikRef = useRef(null);
  // const [descName, setDescName] = useState('');
  // Initialize state for initial values

  const getPreviousMonthRange = () => {
    const now = new Date();
    const startOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const endOfPrevMonth = new Date(now.getFullYear(), now.getMonth(), 0);

    return {
      from: startOfPrevMonth,
      to: endOfPrevMonth
    };
  };

  const { from, to } = getPreviousMonthRange();

  const [initialValues, setInitialValues] = useState({
    invoice_number: '',
    office_id: null,
    invoice_date: new Date(),
    currency_id: null,
    company_id: null,
    client_id: null,
    primary_email: '',
    invoice_email: [],
    department_id: [],
    payment_method_id: [],
    time_sheet: [],
    request_type_id: '',
    client_approval_date: '',
    due_date: '',
    purchase_value: '',
    purchase_type: '',
    invoice_details: [
      {
        services_from: from,
        services_to: to,
        services: [
          {
            service_description: '',
            quantity: '',
            unit_measurement_id: null,
            rate: '',
            amount: ''
          }
        ]
      }
    ]
  });
  const navigate = useNavigate();
  const [files, setFiles] = React.useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [pendingModal, setPendingModal] = useState(false);
  // const [invoice_date, setinvoice_date] = useState(new Date());
  const { activeDeptData } = useSelector((state) => state.department);
  const { addressData } = useSelector((state) => state.global);
  const { invoiceNumberData, paymentMethodData, paymentTypeData, pendingPaymentData } = useSelector(
    (state) => state.payment
  );
  const { activeUom } = useSelector((state) => state.uom);
  const { currencyActiveData } = useSelector((state) => state.currency);
  const { activeCompanyData } = useSelector((state) => state.company);
  const { companyClientData } = useSelector((state) => state.client);
  // const { invoice, total, currency } = pendingPaymentData;

  const dispatch = useDispatch();
  const { REACT_APP_API_URL } = process.env;
  useEffect(() => {
    dispatch(DeptAction.getActiveItem());
    dispatch(CurrencyAction.getActiveItem());
    dispatch(CompanyAction.getActiveItem());
    dispatch(UomAction.getActiveAll());
    dispatch(globalAction.getAddress());
    // dispatch(PaymentAction.getInvoiceNumber());
    dispatch(PaymentAction.getPaymentMethod());
    dispatch(PaymentAction.getPaymentType());
  }, [dispatch]);

  // Default the "Payment Request type" to Full Payment once the options load.
  useEffect(() => {
    if (paymentTypeData && paymentTypeData.length > 0) {
      const fullPayment = paymentTypeData.find(
        (item) => item.type?.toLowerCase() === 'full payment'
      );
      if (fullPayment) {
        setInitialValues((prev) =>
          prev.request_type_id ? prev : { ...prev, request_type_id: fullPayment._id }
        );
        if (formikRef.current && !formikRef.current.values.request_type_id) {
          formikRef.current.setFieldValue('request_type_id', fullPayment._id);
        }
      }
    }
  }, [paymentTypeData]);

  const calculateAmount = React.useCallback(
    (qtyValue, rateValue, index, childIndex, setFieldValue) => {
      const quantity = parseFloat(qtyValue);
      const rate = parseFloat(rateValue);
      const amount = quantity * rate;
      const amountValue = Number.isNaN(amount) ? 0 : amount;
      setFieldValue(
        `invoice_details.${index}.services.${childIndex}.amount`,
        amountValue.toFixed(2)
      );
      // let total = 0;
      // values.invoice_details.forEach((detail) => {
      //   detail.services.forEach((service) => {
      //     total += parseFloat(service.amount) || 0;
      //   });
      // });
      // setToalAmount(total);
    }
  );

  useEffect(() => {
    if (clientInfo || invoiceNumberData) {
      setInitialValues((prevValues) => ({
        ...prevValues,
        client_id: clientInfo || null,
        primary_email: clientInfo?.email || '',
        department_id: clientInfo?.departments || [],
        invoice_number: invoiceNumberData || '',
        currency_id: clientInfo?.currency || { name: '', id: '' },
        payment_method_id: clientInfo?.payment_method || []
      }));
    }
  }, [clientInfo, invoiceNumberData]);

  const handleCompanyChanges = (newValue, setFieldValue) => {
    if (newValue && newValue._id) {
      dispatch(ClientAction.getCompanyClient(newValue._id));
    }
    setInitialValues({
      ...initialValues,
      client_id: null,
      primary_email: '',
      invoice_email: [],
      department_id: [],
      currency_id: null
    });
    setClientInfo(null);
    setFieldValue('client_id', null);
    setFieldValue('primary_email', '');
    setFieldValue('invoice_email', []);
    setFieldValue('department_id', []);
    setFieldValue('currency_id', null);
  };

  const handleClientChange = (newValue, setFieldValue) => {
    if (newValue) {
      if (newValue?._id) {
        dispatch(PaymentAction.getPendingPayment(newValue._id, setPendingModal));
      }
    }
    const defaultValues = {
      client_id: null,
      primary_email: '',
      invoice_email: [],
      department_id: [],
      currency_id: null,
      payment_method_id: [],
      purchase_type: '',
      purchase_value: ''
    };
    const hasContractDate = !!newValue?.contract_date;
    const updatedValues = newValue
      ? {
          client_id: newValue || null,
          primary_email: newValue.email || '',
          // Secondary emails saved on the client pre-fill the request; they
          // stay editable and are stored on the invoice from here on.
          invoice_email: newValue.secondary_email || [],
          department_id: newValue.departments || [],
          currency_id: newValue.currency || null,
          payment_method_id: newValue.payment_method || [],
          purchase_type: hasContractDate ? 'contract_date' : '',
          purchase_value: hasContractDate ? newValue.contract_date : ''
        }
      : defaultValues;
    setPurchateType(hasContractDate ? 'contract_date' : '');
    setInitialValues({ ...initialValues, ...updatedValues });
    Object.entries(updatedValues).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
  };

  // const handleClientChange = (newValue, setFieldValue) => {
  //   if (newValue) {
  //     setInitialValues({
  //       ...initialValues,
  //       client_id: newValue || null,
  //       primary_email: newValue.email || '',
  //       department_id: newValue.departments || [],
  //       currency_id: newValue.currency || null
  //     });
  //     setFieldValue('client_id', newValue);
  //     setFieldValue('primary_email', newValue.email);
  //     setFieldValue('department_id', newValue.departments);
  //     setFieldValue('currency_id', newValue.currency);
  //   } else {
  //     setFieldValue('client_id', null);
  //     setFieldValue('primary_email', '');
  //     setFieldValue('department_id', []);
  //     setFieldValue('currency_id', null);
  //     setInitialValues({
  //       ...initialValues,
  //       client_id: null,
  //       primary_email: '',
  //       department_id: [],
  //       currency_id: null
  //     });
  //   }
  // };

  const onChange = (fileList) => {
    // const newData = fileList.map((item) => item.file);
    setFiles(fileList);
    setInitialValues({
      ...initialValues,
      time_sheet: fileList
    });
  };
  const onErrorChange = (errors) => {
    if (errors) {
      setFiles([]);
    }
  };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  // const handleServiceDescReset = (name, setFieldValue) => {
  //   console.log('dssdsd', name);
  //   setFieldValue(name, null);
  // };

  // console.log(initialValues, 'initialValues');

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/payment-request">
            Payment Request
          </Typography>
          <Typography component="h2" variant="h2">
            / Add
          </Typography>
        </Stack>
      </div>
      <Formik
        innerRef={formikRef}
        validateOnChange={false}
        initialValues={initialValues}
        validationSchema={ValidatePaymentRequest}
        // enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const newValues = { ...initialValues };
          if (newValues.department_id.length > 0) {
            const departmentIds = newValues.department_id.map((item) => item._id);
            newValues.department_id = departmentIds;
          }
          if (newValues.payment_method_id.length > 0) {
            const paymentIds = newValues.payment_method_id.map((item) => item._id);
            newValues.payment_method_id = paymentIds;
          }

          if (newValues.client_id && newValues.client_id?._id) {
            newValues.client_id = newValues.client_id._id;
          }

          if (newValues.currency_id && newValues.currency_id?._id) {
            newValues.currency_id = newValues.currency_id._id;
          }

          if (values.invoice_details.length > 0) {
            const updatedInvoiceDetails = values.invoice_details.map((detail) => ({
              ...detail,
              services_from: dateFormat(detail.services_from, 'yyyy-mm-dd'),
              services_to: dateFormat(detail.services_to, 'yyyy-mm-dd'),
              services: detail.services.map((service) => ({
                ...service,
                unit_measurement_id: service.unit_measurement_id._id
              }))
            }));
            newValues.invoice_details = updatedInvoiceDetails;
          }
          newValues.invoice_date = dateFormat(newValues.invoice_date, 'yyyy-mm-dd');

          const newData = files.map((item) => item.file);
          newValues.time_sheet = newData;

          dispatch(PaymentAction.add(newValues, setErrors, setSubmitting, navigate));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleReset,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setFieldTouched
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Payment Details" />
                  <CardContent>
                    <Field
                      name="office_id"
                      component={Autocomplete}
                      options={addressData ?? []}
                      onChange={(e, newvalue) => {
                        setVelanAddress(newvalue);
                        if (newvalue && newvalue._id) {
                          setInitialValues((prev) => ({
                            ...prev,
                            office_id: newvalue._id
                          }));
                          setFieldValue('office_id', newvalue);

                          dispatch(PaymentAction.getInvoiceNumber(newvalue._id));
                        } else {
                          setFieldValue('office_id', null);
                          setFieldValue('invoice_number', '');
                          setInitialValues((prev) => ({ ...prev, invoice_number: '' }));
                        }
                      }}
                      value={velanAddress}
                      sx={{ width: '300px' }}
                      getOptionLabel={(option) => option.address_type || ''}
                      isOptionEqualToValue={(option, value) => option._id === value?._id}
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.address_type}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="office_id"
                          error={touched.office_id && !!errors.office_id}
                          helperText={touched.office_id && errors.office_id}
                          label="Office Name"
                          placeholder="Search Office"
                          variant="outlined"
                          margin="normal"
                          InputLabelProps={{ required: true }}
                        />
                      )}
                    />
                    <Divider sx={{ pb: 2, mb: 2.5 }} />
                    <Grid container columnSpacing={2}>
                      <Grid item md={4} lg={4}>
                        <Box className="velanAddressInfo">
                          {velanAddress?.logo && (
                            <img
                              src={`${REACT_APP_API_URL}/${velanAddress.logo}`}
                              alt="Velan Logo"
                              width="180"
                              height="45"
                            />
                          )}
                          <Typography className="" component="p" variant="body1">
                            {velanAddress?.full_address}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={4}>
                        <Field
                          name="invoice_number"
                          component={TextField}
                          fullWidth
                          id="invoice_number"
                          label="Invoice Number"
                          variant="outlined"
                          disabled
                          // defaultValue={invoiceNumberData ? invoiceNumberData.toString() : ''}
                          margin="normal"
                          value={initialValues.invoice_number || ''} // Set value prop to values.invoice_number
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue('invoice_number', initialValues.invoice_number);
                          }}
                          InputProps={{
                            readOnly: true
                          }}
                          error={touched.invoice_number && Boolean(errors.invoice_number)}
                          helperText={touched.invoice_number && errors.invoice_number}
                          // other props...
                        />
                      </Grid>
                      <Grid item md={4} lg={4}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={values.invoice_date}
                            name="invoice_date" // Adding the name attribute here
                            dateFormat="dd MMM yyyy"
                            onChange={(date) => {
                              const newDate = dateFormat(date, 'yyyy-mm-dd');
                              setInitialValues({
                                ...initialValues,
                                invoice_date: newDate
                              });
                              setFieldValue('invoice_date', date);
                            }}
                            // isClearable
                            customInput={
                              <TextField
                                label="Invoice Date"
                                error={touched.invoice_date && Boolean(errors.invoice_date)}
                                helperText={touched.invoice_date && errors.invoice_date}
                                fullWidth
                                margin="normal"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Billing Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="company_id"
                          component={Autocomplete}
                          options={activeCompanyData ?? []}
                          onChange={(e, newvalue) => {
                            setFieldValue('company_id', newvalue);
                            handleCompanyChanges(newvalue, setFieldValue);
                            if (newvalue && newvalue._id) {
                              setInitialValues({
                                ...initialValues,
                                company_id: newvalue._id
                              });
                            }
                          }}
                          value={values.company_id}
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="company_id"
                              error={touched.company_id && !!errors.company_id}
                              helperText={touched.company_id && errors.company_id}
                              label="Company Name"
                              placeholder="Search Company"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="client_id"
                          component={Autocomplete}
                          options={companyClientData ?? []}
                          value={initialValues.client_id}
                          onChange={(e, newvalue) => {
                            setClientInfo(newvalue);
                            // setFieldValue('client_id', newvalue);
                            handleClientChange(newvalue, setFieldValue);
                          }}
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="client_id"
                              error={touched.client_id && !!errors.client_id}
                              helperText={touched.client_id && errors.client_id}
                              label="Client Name"
                              placeholder="Search Client"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="primary_email"
                          // size="small"
                          name="primary_email"
                          value={initialValues.primary_email}
                          label="Client Primary Email"
                          variant="outlined"
                          margin="normal"
                          disabled
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue('primary_email', values.primary_email);
                            setInitialValues({
                              ...initialValues,
                              primary_email: e.target.value
                            });
                          }}
                          error={touched.primary_email && Boolean(errors.primary_email)}
                          helperText={touched.primary_email && errors.primary_email}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3} sx={{ position: 'relative' }}>
                        <Tooltip
                          title="The email field accepts multiple inputs. Please enter emails by typing and press Enter."
                          arrow
                          placement="bottom-start"
                        >
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: '-11px',
                              right: 0
                            }}
                            size="small"
                            aria-label="info"
                          >
                            <HelpIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                        <Field name="invoice_email">
                          {({ field }) => (
                            <Autocomplete
                              {...field}
                              options={[]}
                              multiple
                              freeSolo
                              limitTags={2}
                              onChange={(e, newvalue) => {
                                setInitialValues({
                                  ...initialValues,
                                  invoice_email: newvalue
                                });
                                setFieldValue('invoice_email', newvalue);
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const { key, ...tagProps } = getTagProps({ index });
                                  const isInvalidEmail =
                                    errors.invoice_email && errors.invoice_email[index];
                                  return (
                                    <div className="tagsValue" key={index}>
                                      <Tooltip title={isInvalidEmail || option} arrow>
                                        <Chip
                                          size="small"
                                          color={isInvalidEmail ? 'error' : 'secondary'}
                                          variant="outlined"
                                          sx={{ width: '90px !important' }}
                                          label={option}
                                          {...tagProps}
                                          onDelete={() => {
                                            const filteredValues = values.invoice_email.filter(
                                              (_, i) => i !== index
                                            );
                                            setFieldValue('invoice_email', filteredValues);
                                          }}
                                        />
                                      </Tooltip>
                                      {isInvalidEmail && (
                                        <FormHelperText error>
                                          {errors.invoice_email[index]}
                                        </FormHelperText>
                                      )}
                                    </div>
                                  );
                                })
                              }
                              getOptionLabel={(option) => option}
                              renderOption={(props, option) => {
                                return (
                                  <li {...props} key={option._id}>
                                    {option}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={touched.invoice_email && !!errors.invoice_email}
                                  // helperText={touched.invoice_email && errors.invoice_email}
                                  label="Secondary Email"
                                  placeholder="Enter Email"
                                  variant="outlined"
                                  margin="normal"
                                />
                              )}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="department_id"
                          component={Autocomplete}
                          options={activeDeptData ?? []}
                          multiple
                          limitTags={2}
                          value={initialValues.department_id}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          onChange={(e, newvalue) => {
                            setInitialValues({
                              ...initialValues,
                              department_id: newvalue
                            });
                            setFieldValue('department_id', newvalue);
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const { key, ...tagProps } = getTagProps({ index });
                              return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className="tagsValue" key={index}>
                                  <Tooltip title={option.name} arrow>
                                    <Chip
                                      size="small"
                                      sx={{ maxWidth: '60px !important' }}
                                      // title={option.name}
                                      color="secondary"
                                      variant="outlined"
                                      label={option.name}
                                      {...tagProps}
                                      deleteIcon={<HighlightOffOutlinedIcon />}
                                    />
                                  </Tooltip>
                                </div>
                              );
                            })
                          }
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="department_id"
                              error={touched.department_id && !!errors.department_id}
                              helperText={touched.department_id && errors.department_id}
                              label="Department"
                              placeholder="Enter department"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="currency_id"
                          component={Autocomplete}
                          options={currencyActiveData ?? []}
                          value={values.currency_id}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          onChange={(e, newvalue) => {
                            setInitialValues({
                              ...initialValues,
                              currency_id: newvalue
                            });
                            setFieldValue('currency_id', newvalue);
                            if (newvalue && newvalue.short_name) {
                              setCurrencySymbol(newvalue.short_name);
                            }
                          }}
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="currency_id"
                              error={touched.currency_id && !!errors.currency_id}
                              helperText={touched.currency_id && errors.currency_id}
                              label="Currency"
                              placeholder="Search Currency"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={values.client_approval_date}
                            name="client_approval_date" // Adding the name attribute here
                            dateFormat="dd MMM yyyy"
                            maxDate={addDays(new Date(), 1)}
                            onChange={(date) => {
                              const newDate = dateFormat(date, 'yyyy-mm-dd');
                              setInitialValues({
                                ...initialValues,
                                client_approval_date: newDate
                              });
                              setFieldValue('client_approval_date', date);
                            }}
                            // isClearable
                            customInput={
                              <TextField
                                label="Client Approval Date"
                                error={
                                  touched.client_approval_date &&
                                  Boolean(errors.client_approval_date)
                                }
                                helperText={
                                  touched.client_approval_date && errors.client_approval_date
                                }
                                fullWidth
                                margin="normal"
                                // required={false}
                                // InputLabelProps={{ required: true }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={values.due_date}
                            name="due_date" // Adding the name attribute here
                            dateFormat="dd MMM yyyy"
                            minDate={addDays(new Date(), 1)}
                            onChange={(date) => {
                              const newDate = dateFormat(date, 'yyyy-mm-dd');
                              setInitialValues({
                                ...initialValues,
                                due_date: newDate
                              });
                              setFieldValue('due_date', date);
                            }}
                            // isClearable
                            customInput={
                              <TextField
                                label="Due Date"
                                error={touched.due_date && Boolean(errors.due_date)}
                                helperText={touched.due_date && errors.due_date}
                                fullWidth
                                margin="normal"
                                required={false}
                                InputLabelProps={{ required: true }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="payment_method_id"
                          component={Autocomplete}
                          multiple
                          value={values.payment_method_id}
                          options={paymentMethodData ?? []}
                          onChange={(e, newvalue) => {
                            setFieldValue('payment_method_id', newvalue);
                            setInitialValues({
                              ...initialValues,
                              payment_method_id: newvalue
                            });
                          }}
                          // sx={{ width: '400px' }}
                          filterSelectedOptions
                          getOptionLabel={(option) => option.name}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const { key, ...tagProps } = getTagProps({ index });
                              return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className="tagsValue" key={index}>
                                  <Tooltip title={option.name} arrow>
                                    <Chip
                                      size="small"
                                      color="secondary"
                                      variant="outlined"
                                      label={option.name}
                                      {...tagProps}
                                      deleteIcon={<HighlightOffOutlinedIcon />}
                                    />
                                  </Tooltip>
                                </div>
                              );
                            })
                          }
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="payment_method_id"
                              error={touched.payment_method_id && !!errors.payment_method_id}
                              helperText={touched.payment_method_id && errors.payment_method_id}
                              label="Accept Payment Via"
                              placeholder="Search Payment"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <FormControl>
                          <FormLabel id="demo-controlled-radio-buttons-group">
                            Payment Request type
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="request_type_id"
                            value={values.request_type_id}
                            // onChange={handleChange}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                request_type_id: e.target.value
                              });
                              setFieldValue('request_type_id', e.target.value);
                            }}
                          >
                            {paymentTypeData &&
                              paymentTypeData.map((item) => {
                                return (
                                  <FormControlLabel
                                    key={item._id}
                                    value={item._id}
                                    control={<Radio />}
                                    label={item.type}
                                  />
                                );
                              })}
                          </RadioGroup>
                        </FormControl>
                        <FormHelperText error>
                          <ErrorMessage name="request_type_id" component="span" />
                        </FormHelperText>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <FormControl>
                          <FormLabel id="demo-controlled-radio-buttons-group">
                            Payment Purchase Type
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="purchase_type"
                            value={purchaseType}
                            // onChange={handleChange}
                            onChange={(e) => {
                              handleChange(e);
                              setPurchateType(e.target.value);
                              setInitialValues({
                                ...initialValues,
                                purchase_type: e.target.value,
                                purchase_value: ''
                              });
                              setFieldValue('purchase_type', e.target.value);
                              setFieldValue('purchase_value', '');
                              setFieldTouched('purchase_value', false, false);
                            }}
                          >
                            <FormControlLabel
                              value="po_number"
                              control={<Radio />}
                              label="PO Number"
                            />
                            <FormControlLabel
                              value="contract_date"
                              control={<Radio />}
                              label="Contract Date"
                            />
                          </RadioGroup>
                          {purchaseType && (
                            <Button
                              type="button"
                              size="small"
                              color="info"
                              sx={{ alignSelf: 'flex-start', textTransform: 'none', p: 0 }}
                              onClick={() => {
                                setPurchateType('');
                                setFieldValue('purchase_type', '');
                                setFieldValue('purchase_value', '');
                                setFieldTouched('purchase_type', false, false);
                                setFieldTouched('purchase_value', false, false);
                                setInitialValues({
                                  ...initialValues,
                                  purchase_type: '',
                                  purchase_value: ''
                                });
                              }}
                            >
                              Clear selection
                            </Button>
                          )}
                        </FormControl>
                        <FormHelperText error>
                          <ErrorMessage name="purchase_type" component="span" />
                        </FormHelperText>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        {purchaseType === 'po_number' && (
                          <TextField
                            fullWidth
                            id="purchase_value"
                            name="purchase_value"
                            value={initialValues.purchase_value}
                            label="Purchasae Order Number"
                            variant="outlined"
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setInitialValues({
                                ...initialValues,
                                purchase_value: e.target.value
                              });
                              setFieldValue('purchase_value', e.target.value);
                            }}
                            error={touched.purchase_value && Boolean(errors.purchase_value)}
                            helperText={touched.purchase_value && errors.purchase_value}
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        )}
                        {purchaseType === 'contract_date' && (
                          <Box className="datepicker">
                            <DatePicker
                              selected={
                                initialValues.purchase_value
                                  ? new Date(initialValues.purchase_value)
                                  : null
                              }
                              name="purchase_value" // Adding the name attribute here
                              dateFormat="dd MMM yyyy"
                              maxDate={new Date()}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              onChange={(date) => {
                                const newDate = dateFormat(date, 'yyyy-mm-dd');
                                setInitialValues({
                                  ...initialValues,
                                  purchase_value: newDate
                                });
                                setFieldValue('purchase_value', newDate);
                              }}
                              // isClearable
                              customInput={
                                <TextField
                                  label="Contract Date"
                                  error={touched.purchase_value && Boolean(errors.purchase_value)}
                                  helperText={touched.purchase_value && errors.purchase_value}
                                  fullWidth
                                  margin="normal"
                                  required={false}
                                  InputLabelProps={{ required: true }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          edge="end"
                                          disabled
                                          // color="secondary"
                                        >
                                          <CalendarMonthIcon sx={{ color: '#fff' }} />
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              }
                            />
                          </Box>
                        )}
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <ImageUploading
                          multiple
                          value={files}
                          onChange={onChange}
                          onError={onErrorChange}
                          maxFileSize={5242880}
                          maxNumber={5}
                          dataURLKey="data_url"
                          acceptType={['doc', 'docx', 'pdf', 'xlsx']}
                          allowNonImageType
                        >
                          {({
                            imageList,
                            onImageUpload,
                            // onImageRemoveAll,
                            // onImageUpdate,
                            onImageRemove,
                            // isDragging,
                            dragProps,
                            // eslint-disable-next-line no-shadow
                            errors
                          }) => (
                            <div className="upload__image-wrapper">
                              <Card
                                sx={{
                                  mt: 1,
                                  height: '56px',
                                  border: '1px solid rgba(20,20,20,0.2)',
                                  p: 1,
                                  pl: 2
                                }}
                                elevation={0}
                              >
                                <CardContent sx={{ p: '0 !important', height: '100%' }}>
                                  <Box onClick={onImageUpload} {...dragProps}>
                                    <Stack
                                      className="upload__helpText"
                                      sx={{ height: '100%' }}
                                      direction="row"
                                      spacing={2}
                                      justifyContent="space-between"
                                      alignItems="center"
                                    >
                                      <Typography
                                        className="upload_content"
                                        variant="body1"
                                        component="p"
                                      >
                                        Timesheet
                                      </Typography>
                                      <IconButton aria-label="upload">
                                        <UploadIcon />
                                      </IconButton>
                                    </Stack>
                                  </Box>
                                </CardContent>
                              </Card>
                              <FormHelperText>File Formats: Excel, PDF, Docx </FormHelperText>
                              {errors ? (
                                <FormHelperText error>
                                  {errors.acceptType && (
                                    <span>Only .doc, .docx, .pdf and .xlsx format allowed!</span>
                                  )}
                                  {errors.maxFileSize && (
                                    <span>File size should not exceed 5 MB</span>
                                  )}
                                  {errors.maxNumber && (
                                    <span>You cannot upload more than 5 files</span>
                                  )}
                                </FormHelperText>
                              ) : (
                                ''
                              )}
                              <Stack direction="row" spacing={2}>
                                {imageList && imageList.length > 0
                                  ? imageList.map((image, index) => {
                                      return (
                                        <Tooltip
                                          key={index}
                                          title={
                                            image.file && image.file.name
                                              ? image.file.name
                                              : 'uploaded file name'
                                          }
                                        >
                                          <Chip
                                            key={index}
                                            color="info"
                                            label={
                                              image.file && image.file.name
                                                ? image.file.name
                                                : 'uploaded file name'
                                            }
                                            onDelete={onImageRemove}
                                            deleteIcon={<HighlightOffOutlinedIcon />}
                                          />
                                        </Tooltip>
                                      );
                                    })
                                  : ''}
                              </Stack>
                            </div>
                          )}
                        </ImageUploading>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader title="Inovice Details" />
                  <CardContent>
                    <FieldArray name="invoice_details">
                      {(arrayHelpers) => (
                        <>
                          {values.invoice_details.map((service, index) => (
                            <React.Fragment key={index}>
                              <Grid
                                container
                                key={index}
                                rowSpacing={2}
                                columnSpacing={2}
                                alignItems="center"
                              >
                                <Grid item xs={4} xl={3} className="datepicker">
                                  <DatePicker
                                    selected={service.services_from}
                                    selectsStart
                                    dateFormat="dd MMM yyyy"
                                    startDate={service.services_from}
                                    endDate={service.services_to}
                                    onChange={(date) => {
                                      arrayHelpers.replace(index, {
                                        ...service,
                                        services_from: date,
                                        services_to: null
                                      });
                                      // setFieldValue(`invoice_details.${index}.services_from`, date);
                                      // setFieldValue(`invoice_details.${index}.services_to`, null);
                                    }}
                                    customInput={
                                      <TextField
                                        label="Service From"
                                        fullWidth
                                        margin="normal"
                                        error={
                                          touched.invoice_details?.[index]?.services_from &&
                                          Boolean(errors.invoice_details?.[index]?.services_from)
                                        }
                                        helperText={
                                          touched.invoice_details?.[index]?.services_from &&
                                          errors.invoice_details?.[index]?.services_from
                                        }
                                        required={false}
                                        InputLabelProps={{ required: true }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <IconButton
                                                aria-label="toggle password visibility"
                                                edge="end"
                                                disabled
                                              >
                                                <CalendarMonthIcon sx={{ color: '#fff' }} />
                                              </IconButton>
                                            </InputAdornment>
                                          )
                                        }}
                                      />
                                    }
                                  />
                                </Grid>
                                <Grid item xs={4} xl={3} className="datepicker">
                                  <DatePicker
                                    selected={service.services_to}
                                    selectsEnd
                                    dateFormat="dd MMM yyyy"
                                    startDate={service.services_from}
                                    endDate={service.services_to}
                                    minDate={service.services_from}
                                    onChange={(date) => {
                                      arrayHelpers.replace(index, {
                                        ...service,
                                        services_to: date
                                      });
                                      // setFieldValue(`invoice_details.${index}.services_to`, date);
                                    }}
                                    customInput={
                                      <TextField
                                        label="Service To"
                                        fullWidth
                                        margin="normal"
                                        error={
                                          touched.invoice_details?.[index]?.services_to &&
                                          Boolean(errors.invoice_details?.[index]?.services_to)
                                        }
                                        helperText={
                                          touched.invoice_details?.[index]?.services_to &&
                                          errors.invoice_details?.[index]?.services_to
                                        }
                                        required={false}
                                        InputLabelProps={{ required: true }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <IconButton
                                                aria-label="toggle password visibility"
                                                edge="end"
                                                disabled
                                              >
                                                <CalendarMonthIcon sx={{ color: '#fff' }} />
                                              </IconButton>
                                            </InputAdornment>
                                          )
                                        }}
                                      />
                                    }
                                  />
                                </Grid>
                                <Grid item md={1} lg={1} sx={{ textAlign: 'center' }}>
                                  {index > 0 ? (
                                    <IconButton
                                      className="iconAddRemove"
                                      color="secondary"
                                      sx={{ padding: '8px 10px !important' }}
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <RemoveOutlinedIcon />
                                    </IconButton>
                                  ) : (
                                    <IconButton
                                      className="iconAddRemove"
                                      color="secondary"
                                      type="button"
                                      sx={{ padding: '8px 10px !important' }}
                                      onClick={() =>
                                        arrayHelpers.push({
                                          services_from: from,
                                          services_to: to,
                                          services: [
                                            {
                                              service_description: '',
                                              quantity: '',
                                              unit_measurement_id: null,
                                              rate: '',
                                              amount: ''
                                            }
                                          ]
                                        })
                                      }
                                    >
                                      <AddOutlinedIcon />
                                    </IconButton>
                                  )}
                                </Grid>
                              </Grid>
                              <Card
                                sx={{
                                  borderRadius: '0px',
                                  my: 2,
                                  border: '1px solid rgba(0,0,0,0.3)'
                                }}
                              >
                                <CardContent sx={{ p: '20px !important' }}>
                                  <FieldArray name={`invoice_details.${index}.services`}>
                                    {(childArrayHelpers) => (
                                      <>
                                        {service.services.map((item, childIndex) => (
                                          <Grid container columnSpacing={2} key={childIndex}>
                                            <Grid item md={4} lg={4}>
                                              {/* <Field
                                               >
                                                {({ field }) => ( */}
                                              <TextField
                                                name={`invoice_details.${index}.services.${childIndex}.service_description`}
                                                label="Description"
                                                multiline
                                                rows={2}
                                                value={item.service_description}
                                                fullWidth
                                                margin="normal"
                                                required={false}
                                                InputLabelProps={{ required: true }}
                                                onBlur={(event) => {
                                                  // setDescName(
                                                  //   `invoice_details.${index}.services.${childIndex}.service_description`
                                                  // );
                                                  setFieldValue(
                                                    `invoice_details.${index}.services.${childIndex}.service_description`,
                                                    event.target.value
                                                  );
                                                }}
                                                onChange={(event) => {
                                                  handleChange(event);
                                                  // setFieldValue(
                                                  //   `invoice_details.${index}.services.${childIndex}.service_description`,
                                                  //   event.target.value
                                                  // );
                                                  // event.persist();
                                                  // const fieldName = `invoice_details.${index}.services.${childIndex}.service_description`;
                                                  // const { value } = event.target;
                                                  // debouncedOnChange(
                                                  //   fieldName,
                                                  //   value,
                                                  //   setFieldValue
                                                  // );
                                                }}
                                                error={
                                                  touched.invoice_details?.[index]?.services?.[
                                                    childIndex
                                                  ]?.service_description &&
                                                  Boolean(
                                                    errors.invoice_details?.[index]?.services?.[
                                                      childIndex
                                                    ]?.service_description
                                                  )
                                                }
                                                helperText={
                                                  touched.invoice_details?.[index]?.services?.[
                                                    childIndex
                                                  ]?.service_description &&
                                                  errors.invoice_details?.[index]?.services?.[
                                                    childIndex
                                                  ]?.service_description
                                                }
                                              />
                                            </Grid>
                                            <Grid item md={1} lg={1}>
                                              <Field
                                                name={`invoice_details.${index}.services.${childIndex}.quantity`}
                                              >
                                                {({ field }) => (
                                                  <TextField
                                                    {...field}
                                                    label="Qty"
                                                    fullWidth
                                                    // type="number"
                                                    // min={1}
                                                    margin="normal"
                                                    variant="outlined"
                                                    required={false}
                                                    InputLabelProps={{ required: true }}
                                                    InputProps={{
                                                      inputComponent: QuantityNumberField
                                                    }}
                                                    onChange={(event) => {
                                                      field.onChange(event);
                                                      calculateAmount(
                                                        event.target.value,
                                                        values.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.rate,
                                                        index,
                                                        childIndex,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    error={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.quantity &&
                                                      Boolean(
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.quantity
                                                      )
                                                    }
                                                    helperText={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.quantity &&
                                                      errors.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.quantity
                                                    }
                                                  />
                                                )}
                                              </Field>
                                            </Grid>
                                            <Grid item md={2} lg={2}>
                                              <Field
                                                name={`invoice_details.${index}.services.${childIndex}.unit_measurement_id`}
                                                component={Autocomplete}
                                                options={activeUom ?? []}
                                                value={item.unit_measurement_id}
                                                onChange={(e, newvalue) => {
                                                  handleChange(e);
                                                  setFieldValue(
                                                    `invoice_details.${index}.services.${childIndex}.unit_measurement_id`,
                                                    newvalue
                                                  );
                                                  // if (newvalue && newvalue._id) {
                                                  //   setFieldValue(
                                                  //     `invoice_details.${index}.services.${childIndex}.unit_measurement_id`,
                                                  //     newvalue._id
                                                  //   );
                                                  // } else {
                                                  //   setFieldValue(
                                                  //     `invoice_details.${index}.services.${childIndex}.unit_measurement_id`,
                                                  //     null
                                                  //   );
                                                  // }
                                                }}
                                                getOptionLabel={(option) => option.name}
                                                renderOption={(props, option) => {
                                                  return (
                                                    <li {...props} key={option._id}>
                                                      {option.name}
                                                    </li>
                                                  );
                                                }}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    name={`invoice_details.${index}.services.${childIndex}.unit_measurement_id`}
                                                    error={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.unit_measurement_id &&
                                                      Boolean(
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.unit_measurement_id
                                                      )
                                                    }
                                                    helperText={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.unit_measurement_id &&
                                                      errors.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.unit_measurement_id
                                                    }
                                                    label="UOM"
                                                    placeholder="Search UOM"
                                                    variant="outlined"
                                                    margin="normal"
                                                    required={false}
                                                    InputLabelProps={{ required: true }}
                                                    // SelectProps={{
                                                    //   IconComponent: ExpandMore
                                                    // }}
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item md={2} lg={2}>
                                              <Field
                                                name={`invoice_details.${index}.services.${childIndex}.rate`}
                                              >
                                                {({ field }) => (
                                                  <TextField
                                                    {...field}
                                                    label="Rate"
                                                    fullWidth
                                                    margin="normal"
                                                    variant="outlined"
                                                    required={false}
                                                    InputLabelProps={{ required: true }}
                                                    InputProps={{
                                                      inputComponent: DecimalNumberField
                                                    }}
                                                    onChange={(event) => {
                                                      field.onChange(event);
                                                      calculateAmount(
                                                        values.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.quantity,
                                                        event.target.value,
                                                        index,
                                                        childIndex,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    error={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.rate &&
                                                      Boolean(
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.rate
                                                      )
                                                    }
                                                    helperText={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.rate &&
                                                      errors.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.rate
                                                    }
                                                  />
                                                )}
                                              </Field>
                                            </Grid>
                                            <Grid item md={2} lg={2}>
                                              <Field
                                                name={`invoice_details.${index}.services.${childIndex}.amount`}
                                              >
                                                {({ field }) => (
                                                  <TextField
                                                    {...field}
                                                    label="Amount"
                                                    fullWidth
                                                    value={item.amount}
                                                    margin="normal"
                                                    required={false}
                                                    InputLabelProps={{ required: true }}
                                                    onChange={(event) => {
                                                      field.onChange(event);
                                                      // calculateTotalAmount(values);
                                                    }}
                                                    InputProps={{
                                                      readOnly: true,
                                                      inputComponent: DecimalNumberField,
                                                      startAdornment: (
                                                        <InputAdornment position="start">
                                                          {currencySymbol}
                                                        </InputAdornment>
                                                      )
                                                    }}
                                                    error={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.amount &&
                                                      Boolean(
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.amount
                                                      )
                                                    }
                                                    helperText={
                                                      touched.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.amount &&
                                                      errors.invoice_details?.[index]?.services?.[
                                                        childIndex
                                                      ]?.amount
                                                    }
                                                  />
                                                )}
                                              </Field>
                                            </Grid>
                                            <Grid item md={1} lg={1} sx={{ textAlign: 'center' }}>
                                              {childIndex > 0 ? (
                                                <IconButton
                                                  className="iconAddRemove"
                                                  color="secondary"
                                                  sx={{ mt: 3, padding: '8px 10px !important' }}
                                                  onClick={() =>
                                                    childArrayHelpers.remove(childIndex)
                                                  }
                                                >
                                                  <RemoveOutlinedIcon />
                                                </IconButton>
                                              ) : (
                                                <IconButton
                                                  className="iconAddRemove"
                                                  color="secondary"
                                                  type="button"
                                                  sx={{ mt: 3, padding: '8px 10px !important' }}
                                                  onClick={() =>
                                                    childArrayHelpers.push({
                                                      service_description: '',
                                                      quantity: '',
                                                      unit_measurement_id: null,
                                                      rate: '',
                                                      amount: ''
                                                    })
                                                  }
                                                >
                                                  <AddOutlinedIcon />
                                                </IconButton>
                                              )}
                                            </Grid>
                                          </Grid>
                                        ))}
                                      </>
                                    )}
                                  </FieldArray>
                                </CardContent>
                              </Card>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </FieldArray>
                  </CardContent>
                  {/* <CardActions sx={{ justifyContent: 'center' }}>
                    <Typography component="p" variant="body1">
                      {totalAmount}
                    </Typography>
                  </CardActions> */}
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Preview'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/payment-request');
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                        setPurchateType('');
                        // handleServiceDescReset(descName, setFieldValue);
                        setInitialValues({
                          office_id: '',
                          invoice_date: new Date(),
                          company_id: '',
                          client_id: null,
                          primary_email: '',
                          invoice_email: [],
                          department_id: [],
                          payment_method_id: [],
                          time_sheet: [],
                          client_approval_date: '',
                          due_date: '',
                          purchase_value: ''
                        });
                        // navigate('/payment-request');
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      {pendingModal === true && pendingPaymentData && Object.keys(pendingPaymentData).length > 0 ? (
        <PendingPaymentRequest
          openmodal={pendingModal}
          data={pendingPaymentData}
          // currency={currency}
          // total={total}
          onCloseModal={() => setPendingModal(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
export default PaymentRequestAdd;
